import { HTMLAttributes } from 'react';

import { Spin } from 'antd';
import cn from 'classnames';

import styles from './OverlayLoader.module.scss';

export interface IOverlayLoaderProps extends HTMLAttributes<HTMLDivElement> {
	opacity?: number;
	zIndex?: number;
}

export const OverlayLoader = ({ className, opacity = 0.6, zIndex = 100, ...props }: IOverlayLoaderProps) => {
	return (
		<div
			{...props}
			className={cn(className, styles.overlayLoader)}
			style={{ backgroundColor: `rgb(255 255 255 / ${opacity})`, zIndex: zIndex }}>
			<Spin size="large" />
		</div>
	);
};

export default OverlayLoader;
